import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/searchItineraryAddresses'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class searchItineraryAddressesStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "searchItineraryAddressesStore",
			variables: true,
		})
	}
}

export async function load_searchItineraryAddresses(params) {
  await initClient()

	const store = new searchItineraryAddressesStore()

	await store.fetch(params)

	return {
		searchItineraryAddresses: store,
	}
}
